import { join } from 'lodash';

export default list => join(list, ', ');
